// extracted by mini-css-extract-plugin
module.exports = {"section":"our-values-module--section--1NuXJ","motto":"our-values-module--motto--3fKOb","images":"our-values-module--images--2PeIW","img":"our-values-module--img--9vmD8"};